import { render } from "./ThorondorMarkdownArticle.vue?vue&type=template&id=ccfb6ffc&scoped=true"
import script from "./ThorondorMarkdownArticle.vue?vue&type=script&lang=js"
export * from "./ThorondorMarkdownArticle.vue?vue&type=script&lang=js"

import "./ThorondorMarkdownArticle.vue?vue&type=style&index=0&id=ccfb6ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccfb6ffc"]])

export default __exports__